import * as Sentry from '@sentry/vue'
import { axiosFingerprintProcessor } from './sentryAxiosFingerprint'
import { detectEnvironment } from './sentryEnvironment'

// Split the AxiosError catch-all (PORTAL-CLIENT-5X1): group by endpoint + status
// instead of the (identical, useless) axios-internal stack. Registered on the
// global scope so it runs for every module that imports this wrapper, before
// each module's own beforeSend.
Sentry.addGlobalEventProcessor(axiosFingerprintProcessor)

// Label events with the runtime environment so dev-portal/localhost traffic
// stops reporting as environment:production. Defaulted here (not in the 13
// module main.js inits) so every module gets it; an explicit `environment`
// in a module's init still wins.
const init = (options = {}) => Sentry.init({ environment: detectEnvironment(), ...options })

// Build the Sentry identity from a user profile. Staff username IS the email, so
// fall back to it — `||` (not `??`) so an empty-string email also falls back —
// and lowercase to match Sentry's case-sensitive user.email join.
const toSentryUser = (user) =>
  user ? { id: user.id, username: user.username, email: (user.email || user.username)?.toLowerCase() } : null

export default { ...Sentry, init, toSentryUser }
